module.exports = __webpack_public_path__ + "media/home/PartnerIcon-5db3ece0.png";